import { render, staticRenderFns } from "./hostPost.vue?vue&type=template&id=22b26cd8&scoped=true"
import script from "./hostPost.vue?vue&type=script&lang=js"
export * from "./hostPost.vue?vue&type=script&lang=js"
import style0 from "./hostPost.vue?vue&type=style&index=0&id=22b26cd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b26cd8",
  null
  
)

export default component.exports